<template>
    <div class="uik-highlight-card-pattern">
        <component :is="'Pattern' + type"/>
    </div>
</template>

<script>
import Pattern1 from "./Components/Pattern1"
import Pattern2 from "./Components/Pattern2"
import Pattern3 from "./Components/Pattern3"
import Pattern4 from "./Components/Pattern4"
import Pattern5 from "./Components/Pattern5"
import Pattern6 from "./Components/Pattern6"
import Pattern7 from "./Components/Pattern7"
import Pattern8 from "./Components/Pattern8"
import Pattern9 from "./Components/Pattern9"

export default {
    components: {
        Pattern1,
        Pattern2,
        Pattern3,
        Pattern4,
        Pattern5,
        Pattern6,
        Pattern7,
        Pattern8,
        Pattern9
    },
    props: {
        /**
         * Pattern
         */
        type: {
            type: [String, Number],
            default: 1,
            validator (value) {
                value = parseFloat(value)
                if (!isNaN(value) && value > 0 && value < 10) return true

                return false
            }
        }
    }
}
</script>

<style lang="scss">
.uik-highlight-card-pattern {
  position: absolute;
  z-index: 0;
  width: 100%;
  height: 100%;
  left: 50%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  overflow: hidden;

  svg {
    fill: white;
    opacity: 0.2;
    width: 100%;
  }
}
</style>
